export default {"src":"/_next/static/media/FREECASH.e3e9eed8.svg","height":28,"width":177,"blurWidth":0,"blurHeight":0};